import AnimatedNumber from "@/components/AnimatedNumber";

const STATS = [
    { value: "+20", label: "Años de experiencia en arquitectura textil" },
    { value: "+10,000", label: "Techos instalados en Latinoamérica" },
    { value: "+30", label: "Ciudades con instalación propia" },
    { value: "IFAI 2021", label: "Premio internacional en tensoestructuras" },
];

export default function StatsBar() {
    return (
        <section data-testid="stats-bar" className="bg-eclipse-primary py-16 sm:py-20">
            <div className="container-eclipse">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
                    {STATS.map((s) => (
                        <div key={s.value} className="text-center sm:text-left" data-testid={`stat-${s.value.replace(/\W/g, "").toLowerCase()}`}>
                            <div className="font-display font-black text-eclipse-cta text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-2 leading-none">
                                <AnimatedNumber value={s.value} />
                            </div>
                            <p className="text-white/75 text-xs sm:text-sm leading-relaxed max-w-[200px] mx-auto sm:mx-0">{s.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
